window.initLoginForm = (props = {
  url,
  googleRecaptchaSiteKey,
}) => {
  const submitForm = $("#login-form");
  const submitButton = $("#login-form-submit");
  const formErrorsHandler = FormErrorsHandler("login-form");

  function submitLogin() {
    const completeHandler = (xhr) => {
      if (xhr.status == 200) {
        if (xhr.responseJSON && xhr.responseJSON.redirect) {
          location.href = xhr.responseJSON.redirect;
        } else {
          location.reload();
        }
      } else if (xhr.status == 422) {
        formErrorsHandler.setErrors(xhr.responseJSON.errors);
      } else {
        $('.error__window_wrapper').show();
      }

      if (xhr.status != 200) {
        $('.preloader').hide();
        submitButton.prop('disabled', false);
      }
    };

    submitButton.prop('disabled', true);
    $.ajax({
      method: "POST",
      url: props.url,
      dataType: "json",
      data: submitForm.serializeArray(),
      complete: completeHandler,
    });
  }

  submitForm.submit((submitEvent) => {
    submitEvent.preventDefault();
    $('.preloader').show();
    formErrorsHandler.clearAll();

    grecaptcha.ready(() => {
      grecaptcha.execute(
        props.googleRecaptchaSiteKey, {
        action: "login"
      }).then((token) => {
        submitForm.find("input[name=g-recaptcha-response]").val(
          token);
        submitLogin();
      });
    });
  });

};

window.initPasswordReminderForm = (props = {
  url,
  googleRecaptchaSiteKey,
}) => {
  const submitForm = $("#forget-password-form");
  const submitButton = $("#forget-password-submit");
  const formErrorsHandler = FormErrorsHandler("forget-password-form");

  const thanksModal = $("#forget-password-thanks-modal");
  const thanksModalButton = $("#forget-password-thanks-button");
  thanksModalButton.click(() => {
    $.modal.close();
  });

  function submitPasswordReset() {
    const completeHandler = (xhr) => {
      if (xhr.status == 200) {
        window.closePasswordModal();
        thanksModal.modal({
          showClose: false
        });
      } else if (xhr.status == 422) {
        formErrorsHandler.setErrors(xhr.responseJSON.errors);
      } else {
        $('.error__window_wrapper').show();
      }

      submitButton.prop('disabled', false);
      $('.preloader').hide();
    };

    submitButton.prop('disabled', true);
    $.ajax({
      method: "POST",
      url: props.url,
      dataType: "json",
      data: submitForm.serializeArray(),
      complete: completeHandler,
    });
  }

  submitForm.submit((submitEvent) => {
    submitEvent.preventDefault();
    $('.preloader').show();
    formErrorsHandler.clearAll();

    grecaptcha.ready(() => {
      grecaptcha.execute(
        props.googleRecaptchaSiteKey, {
        action: "password_recovery"
      }).then((token) => {
        submitForm.find("input[name=g-recaptcha-response]")
          .val(token);
        submitPasswordReset();
      });
    });
  });
};

window.initRegistrationForm = (props = {
  url,
  googleRecaptchaSiteKey,
  redirectUrl,
}) => {
  const submitForm = $("#register-form");
  const submitButton = $("#register-form-submit");
  const formErrorsHandler = FormErrorsHandler("register-form");

  function submitRegistration() {
    const completeHandler = (xhr) => {
      if (xhr.status == 201) {
        var url = props.redirectUrl || window.location.href;
        if (url.indexOf('?') > -1) {
          url += '&registration_success=1'
        } else {
          url += '?registration_success=1'
        }
        window.location.href = url;
      } else if (xhr.status == 422) {
        formErrorsHandler.setErrors(xhr.responseJSON.errors);
      } else {
        $('.error__window_wrapper').show();
      }

      if (xhr.status != 201) {
        $('.preloader').hide();
        submitButton.prop('disabled', false);
      }
    };

    submitButton.prop('disabled', true);
    $.ajax({
      method: "POST",
      url: props.url,
      dataType: "json",
      data: submitForm.serializeArray(),
      complete: completeHandler,
    });
  }

  submitForm.submit((e) => {
    e.preventDefault();
    $('.preloader').show();
    formErrorsHandler.clearAll();

    grecaptcha.ready(() => {
      grecaptcha.execute(
        props.googleRecaptchaSiteKey, {
        action: "registration"
      }).then((token) => {
        submitForm.find("input[name=g-recaptcha-response]")
          .val(token);
        submitRegistration();
      });
    });
  });
};
